import * as React from "react";
import { Icon } from "@grandvisionhq/icons";
import { useIntl } from "@grandvisionhq/state";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
/* empty css              */
const ToggleIcon = ({ onClick, className, isActive, isDisabled }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      "aria-label": isActive ? getLabel("account.hidePassword") : getLabel("account.showPassword"),
      onClick,
      disabled: isDisabled,
      className
    },
    isActive ? /* @__PURE__ */ React.createElement(Icon, { name: "eye-slash" }) : /* @__PURE__ */ React.createElement(Icon, { name: "eye" })
  );
};
const _Password = class _Password extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      passwordVisible: false
    };
    this.onVisibilityToggle = () => {
      this.setState((prevState) => ({
        passwordVisible: !prevState.passwordVisible
      }));
    };
  }
  render() {
    const { label, errorMessage, ...rest } = this.props;
    const { passwordVisible } = this.state;
    return /* @__PURE__ */ React.createElement("div", { className: "password-container" }, /* @__PURE__ */ React.createElement(
      ConnectedFormControl,
      {
        ...ConnectedFormControl.defaultProps,
        id: "password",
        "data-t": "password",
        "aria-describedby": rest["aria-describedby"],
        type: passwordVisible ? "text" : "password",
        label,
        className: "form-control--password",
        errorMessage,
        ...rest
      }
    ), /* @__PURE__ */ React.createElement(
      ToggleIcon,
      {
        onClick: this.onVisibilityToggle,
        className: "password-toggle",
        isActive: passwordVisible
      }
    ));
  }
};
_Password.defaultProps = {
  required: true,
  validations: []
};
let Password = _Password;
export {
  Password as default
};
//# sourceMappingURL=Password.js.map
